import React, { useEffect, useState } from "react";
import {
  Navbar,
  Container,
  FormControl,
  Nav,
  NavDropdown,
} from "react-bootstrap";
import logo from "../../images/logo2.png";
import NavbarSearchHook from "./../../hook/search/navbar-search-hook";
import GetAllUserCartHook from "./../../hook/cart/get-all-user-cart-hook";
const NavBarLogin = () => {
  const [OnChangeSearch] = NavbarSearchHook();
  let word = "";
  if (localStorage.getItem("searchWord") != null) {
    word = localStorage.getItem("searchWord");
  }

  const [user, setUser] = useState("");
  useEffect(() => {
    if (localStorage.getItem("user") != null) {
      setUser(JSON.parse(localStorage.getItem("user")));
    }
  }, []);

  const logOut = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    setUser("");
  };

  const [itemsNum] = GetAllUserCartHook();
  const [expanded, setExpanded] = useState(false);

  const handleSearchClick = () => {
    setExpanded(!expanded); // تبديل حالة التوسيع
  };

  return (
    <Navbar
      className="sticky-top shadow"
      bg="light"
      variant="light"
      expand="sm"
    >
      <Container>
        <a href="/">
          <img src={logo} alt="sdf" width={70} />
        </a>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <div className="d-flex justify-content-center">
            {expanded ? (
              <FormControl
                value={word}
                onChange={OnChangeSearch}
                type="search"
                placeholder="ابحث..."
                className="text-center mx-4"
                aria-label="Search"
              />
            ) : null}
            <button
              className={`custom-button ${expanded ? "mx-0 shadow" : "mx-4 "}`}
              onClick={handleSearchClick}
            >
              <i className={`fa ${expanded ? "fa-close" : "fa-search"}`}></i>
            </button>
          </div>
          <Nav className="me-auto text-dark fw-bold">
            {user !== "" ? (
              <NavDropdown
                className="text-dark fw-bold mx-auto"
                title={user.name}
                id="basic-nav-dropdown"
              >
                {user.role === "admin" ? (
                  <NavDropdown.Item href="/admin/allproducts">
                    لوحة التحكم
                  </NavDropdown.Item>
                ) : (
                  <NavDropdown.Item href="/user/profile">
                    الصفحه الشخصية
                  </NavDropdown.Item>
                )}
                <NavDropdown.Divider />
                <NavDropdown.Item onClick={logOut} href="/">
                  تسجيل خروج
                </NavDropdown.Item>
              </NavDropdown>
            ) : (
              <Nav.Link
                href="/login"
                className="nav-text d-flex mt-3 justify-content-center text-dark fw-bold"
              >
                <i className="fa fa-user"></i>
                <p>دخول</p>
              </Nav.Link>
            )}
            {user.role === "user" ? (
              <Nav.Link
                href="/cart"
                className="nav-text position-relative d-flex mt-3 justify-content-center  text-dark fw-bold"
              >
                <i className="fa fa-cart-shopping"></i>

                <p>العربه</p>
                <span className="position-absolute top-10 start-0 translate-middle badge rounded-pill bg-danger">
                  {itemsNum || 0}
                </span>
              </Nav.Link>
            ) : null}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavBarLogin;
